import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Button, Card, CardBody, Col, Container, Input, Row } from "reactstrap";
// import { jobCandidates } from "../../../../common/data/appsJobs";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { jobCandidates } from "../../../common/data/appsJobs";
import AddInstitute from "../Component/AddInstitute";

const AffiliatedInstitute = () => {
  const [institutemodal,setInstituteModal] = useState(false);
  const [candidates, setCandidates] = useState(jobCandidates);
  const [formData,setFormData] = useState({
      DestinationCountryId: "",
      Name: "",
      Slug: "",
      City: "",
      Ranking: "",
      LogoMediaId: null, // file object
      Website: "",
      Description: "",
      IsPartner: false,
      IsActive: true,
      rating: [0, "No rating"],
  });

  const toggleModal = () => {
    setFormData({
    DestinationCountryId: "",
    Name: "",
    Slug: "",
    City: "",
    Ranking: "",
    LogoMediaId: "",
    Website: "",
    Description: "",
    IsPartner: "",
    IsActive: true,
    
    });
    setInstituteModal(!institutemodal);
  };


  const handleSubmit =(e)=>{
    e.preventDefault();
    setCandidates([...jobCandidates, formData]);
    toggleModal();
  }

  document.title = "Affiliated Institute | Kangaroo Foundation";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="container-fluid">
          <BreadCrumb title="Institute List" pageTitle="Insitute" />

          <Row className="g-4 mb-4">
            <Col className="col-sm-auto">
            <Button color="secondary" onClick={handleSubmit}>
              <div>
                  <i className="ri-add-line align-bottom me-1"></i> Add
                  Insitute
              </div>
              </Button>
            </Col>
            <Col className="col-sm">
              <div className="d-md-flex justify-content-sm-end gap-2">
                <div className="search-box ms-md-2 flex-shrink-0 mb-3 mb-md-0">
                  <Input
                    type="text"
                    className="form-control"
                    id="searchJob"
                    autoComplete="off"
                    placeholder="Search for institute name"
                  />
                  <i className="ri-search-line search-icon"></i>
                </div>

                <select
                  className="form-control w-sm"
                  data-choices
                  data-choices-search-false
                >
                  <option value="All">All</option>
                  <option value="Today">Today</option>
                  <option value="Yesterday" defaultValue>
                    Yesterday
                  </option>
                  <option value="Last 7 Days">Last 7 Days</option>
                  <option value="Last 30 Days">Last 30 Days</option>
                  <option value="This Month">This Month</option>
                  <option value="Last Year">Last Year</option>
                </select>
              </div>
            </Col>
          </Row>

          <Row className="job-list-row" id="candidate-list">
            {candidates?.map((item, key) => (
              <Col xxl={3} md={6} key={key}>
                <Card>
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        {item.nickname ? (
                          <div className="avatar-lg rounded">
                            <div className="avatar-title border bg-light text-primary rounded text-uppercase fs-24">
                              {item.nickname}
                            </div>
                          </div>
                        ) : (
                          <div className="avatar-lg rounded">
                            <img
                              src={item.userImg}
                              alt=""
                              className="member-img img-fluid d-block rounded"
                            ></img>
                          </div>
                        )}
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <a href="/pages-profile">
                          <h5 className="fs-16 mb-1">{item.candidateName}</h5>
                        </a>
                        <p className="text-muted mb-2">{item.designation}</p>
                        {/* <div className="d-flex flex-wrap gap-2 align-items-center">
                          <div className="badge text-bg-success">
                            <i className="mdi mdi-star me-1"></i>
                            {item.rating[0]}
                          </div>
                          <div className="text-muted">{item.rating[1]}</div>
                        </div> */}
                        <div className="d-flex gap-4 mt-2 text-muted">
                          <div>
                            <i className="ri-map-pin-2-line text-primary me-1 align-bottom"></i>{" "}
                            {item.location}
                          </div>
                          <div>
                            <i className="ri-time-line text-primary me-1 align-bottom"></i>
                            {item.type === "Part Time" ? (
                              <span className="badge bg-danger-subtle text-danger">
                                {item.type}
                              </span>
                            ) : item.type === "Full Time" ? (
                              <span className="badge bg-success-subtle text-success">
                                {item.type}
                              </span>
                            ) : (
                              <span className="badge bg-secondary-subtle text-secondary">
                                {item.type}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

          <Row className="g-0 justify-content-end mb-4" id="pagination-element">
            <Col sm={6}>
              <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                <div className="page-item">
                  <Link to="" className="page-link" id="page-prev">
                    Previous
                  </Link>
                </div>
                <span id="page-num" className="pagination"></span>
                <div className="page-item">
                  <Link to="" className="page-link" id="page-next">
                    Next
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <AddInstitute
        isOpen = {institutemodal}
        toggleModal={toggleModal}
        formData={formData}
        setFormData={setFormData}
        handleSubmit={handleSubmit}
      />
    </React.Fragment>
  );
};

export default AffiliatedInstitute;
